import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Map from "./pages/map";
import Login from "./pages/login";
import Signup from "./pages/signup";
import Profile from "./pages/profile";
import { PrivateRoute } from "./components/PrivateRoute";

export default () => {
  return (
    <Switch>
      <PrivateRoute path="/map" component={Map} />
      <PrivateRoute path="/profile" component={Profile} />
      <Route path="/login" component={Login} />
      <Route path="/signup" component={Signup} />
      <Redirect to="/map" />
    </Switch>
  );
};
